import { defineComponent as _defineComponent } from 'vue'
import { ref, useContext } from '@nuxtjs/composition-api'
import { useNuxtListeners } from '~/lib/composables/useNuxtListeners'

import XSolidIcon from '@/assets/img/XSolidIcon.svg'


export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenOnboardingVideo',
  setup(__props) {

const isOpen = ref(false)

useNuxtListeners({
  'show-fullscreen-onboarding-video': () => {
    isOpen.value = true
  },
})

function closeLightbox() {
  isOpen.value = false
}

return { __sfc: true,isOpen, closeLightbox, XSolidIcon }
}

})